import { FC } from 'react'
import Headline from '../components/common/Headline'
import Space from '../components/common/Space'
import PlayButton from '../components/form/buttons/PlayButton'
import RefreshButton from '../components/form/buttons/RefreshButton'
import ImportsList from '../components/import/ImportsList'
import ImportsTaskList from '../components/import/ImportsTaskList'
import useImports from '../hooks/useImports'
import usePagable from '../hooks/usePagable'
import useTracking from '../hooks/useTracking'
import Page from '../layout/Main/Page'
import { importApi } from '../services/import.api'
import { IPagableRequest } from '../services/IPagable'
import { iniTImportsFilterState, TImportsFilterState } from '../store/importsSlice'

const TrackingPage: FC = () => {
  const { updateTrackingHandle, launchQueueHandle, loading } = useTracking()

  const { importsFilter, setFilterParams } = useImports({})
  const { pagable, pagableState, onSort, loadTriggerComponent, updatePagableApiState } = usePagable(
    {
      initPagable: {
        size: 100,
        sort: 'createdAt',
        sortDirection: 'desc',
      },
      filterMap: importsFilter,
      allowUrlFilterArr: Object.keys(iniTImportsFilterState),
      setFilterParams,
    },
  )

  // -- Load imports catalog
  const {
    data: trackingHistory,
    isFetching: isFetchingTrackingHistory,
    isLoading: isLoadingTrackingHistory,
  } = importApi.useGetTrackingImportsMergeQuery(
    pagableState as IPagableRequest<TImportsFilterState>,
    { skip: !pagableState },
  )

  // -- Load actual tracking list
  const {
    data: actualTracking,
    isFetching: isFetchingActualTracking,
    isLoading: isLoadingActualTracking,
  } = importApi.useGetActualTrackingImportsQuery({})

  return (
    <Page
      header={{
        title: `Update`,
        subTitle: 'Update Products',
        actions: (
          <div className='flex gap-2'>
            {/* <RefreshButton
            type="secondary"
            size="small"
            variant="outline"
            onClick={updateTrackingHandle}
            disabled={loading}
            isLoading={loading}
          >
            Updating&nbsp;Queue
          </RefreshButton>

          <PlayButton
            type="primary"
            size="small"
            variant="outline"
            onClick={launchQueueHandle}
            disabled={loading}
            isLoading={loading}
          >
            Launch&nbsp;Queue
          </PlayButton> */}
          </div>
        ),
      }}
    >
      <hr />
      <Headline upperCase>Current Updating</Headline>
      <ImportsTaskList
        imports={Array.isArray(actualTracking) ? [...actualTracking].reverse() : actualTracking}
        isPending={isFetchingActualTracking || isLoadingActualTracking}
      />
      <Space />

      <ImportsList
        title={<Headline upperCase>Updating History</Headline>}
        imports={trackingHistory?.content}
        pagable={pagable}
        isPending={isFetchingTrackingHistory || isLoadingTrackingHistory}
        loadTriggerComponent={loadTriggerComponent}
        onSort={onSort}
      />
    </Page>
  )
}

export default TrackingPage
